export default function CRISubCategoryDirective() {
  return {
    template: require('./cri-sub-category.html'),
    scope: {
      criFunctionId: '=',
      criCategoryId: '=',
      criSubCategory: '=',
      assessmentId: '=',
      isEdit: '=',
      tooltipAppendToSelector: '@',
      form: '=',
    },
    controller: 'CRISubCategoryController',
    controllerAs: 'criSubCategoryVM',
    bindToController: true,
    replace: true,
  };
}
